import type { Locale } from '@skippay/core/@types/country';

import { NEW_INSTALLMENT_APPLICATION_URL } from './installments';

// base urls
export const URL_BASE = {
	CZ: {
		title: 'skippay.cz',
		url: 'https://skippay.cz',
	},
	SK: {
		title: 'skippay.sk',
		url: 'https://skippay.sk',
	},
	HU: {
		title: 'skippay.hu',
		url: 'https://skippay.hu',
	},
};

// blog is separate static Wordpress application
export const URL_BLOG = `https://skippay.cz/blog`;
export const URL_BLOG_OLD = `https://mallpay.cz/blog`;
export const URL_VOCABULARY = `https://skippay.cz/blog/slovnik-pojmu`;
export const URL_BLOG_PODCAST = `https://skippay.cz/blog/tema/podcasty`;
export const URL_DEVELOPERS_PORTAL = `https://developers.skippay.cz/`;
export const URL_VISUAL_MATERIALS = `https://kulyma.sharepoint.com/:f:/s/Public/ErqHaMMhfkJCmgIsSWBmnx8B8gp_Ku4Gm75ZZoeGQIYZZA?e=zg6DB0`;

export const ABOUT = '/o-skippay';
export const ABOUT_CREDIT_CARD = '/kreditni-karta';
export const ABOUT_DEFERRED_PAYMENT = '/odlozena-platba';
export const ABOUT_HOW_PAY_BY_MALL_PAY = '/jak-zaplatit';
export const ABOUT_INSTALLMENT_PAYMENT = '/nakup-na-splatky';
export const ABOUT_INVESTMENTS = '/investuj-pri-nakupovani';
export const ABOUT_LOANS = '/pujcky';
export const ABOUT_ONLINE_PAYMENT = '/platba-online';
export const ABOUT_OVERDRAFT = '/kontokorent';
export const ABOUT_PAYMENT_BY_CARD = '/platba-kartou';
export const ABOUT_MALL_PAY = '/platba-skip-pay';
export const ABOUT_PAY_IN_THREE = '/nakup-na-tretinu';
export const ABOUT_PAYMENT_GATEWAY = '/platebni-brana';
export const ABOUT_PAYMENT_ON_DELIVERY = '/dobirka';
export const ABOUT_REWARDS = '/odmeny';
export const ABOUT_SHOP_WISELY = '/nakupujte-s-rozumem';
export const ABOUT_TRANSACTION_PAYMENT = '/prevod-penez';
export const ACCOUNT_UPGRADE = '/skip-pay-packages';
export const ADDRESS_BOOK = '/send-payment/address-book';
export const AML_QUESTIONNAIRE = '/aml-questionnaire';
export const APP_STORE_REDIRECT = '/chci-aplikaci';
export const APPLICATIONS_BILLINGS_BASE = '/purchases';
export const APPLICATION_DETAIL = `${APPLICATIONS_BILLINGS_BASE}/bnpl/:applicationId`;
export const APPLICATION_LISTING = APPLICATIONS_BILLINGS_BASE; // Deprecated. Use PURCHASES
export const BILLING_PAYMENT = `${APPLICATIONS_BILLINGS_BASE}/billings/:billingId/pay`;
export const BILLING_PART_PAYMENT = '/pay-part-of-billing';
export const BILLINGS = APPLICATIONS_BILLINGS_BASE; // Deprecated. Use PURCHASES
export const BILLINGS_ALL = APPLICATIONS_BILLINGS_BASE; // Deprecated. Use PURCHASES
export const BILLINGS_ALL_FILTERED = `${APPLICATIONS_BILLINGS_BASE}/filter`;
export const BNPL_LIMIT_MANAGEMENT = '/limit-management';
export const PURCHASES = APPLICATIONS_BILLINGS_BASE;
export const CARD = '/karta';
export const CAREER = '/kariera';
export const CASHBACK = '/cashback';
export const CASHBACK_REDIRECT = '/cashback/redirect';
export const CASHBACK_TRANSACTIONS = '/cashback/transactions';
export const CASHBACK_WALLET = '/cashback/wallet';
export const CONDITIONS = '/vseobecne-obchodni-podminky';
export const CONTACTS = '/kontakty';
export const CONTRACTS_AND_DOCUMENTS = '/contracts-and-documents';
export const CONTRACTS_AND_DOCUMENTS_OTHER = '/contracts-and-documents/others';
export const CONTRACTS_AND_DOCUMENTS_PRICE_LIST = '/contracts-and-documents/pricelist';
export const CONTRACTS_AND_DOCUMENTS_TERMS = '/contracts-and-documents/terms-and-conditions';
export const CONTRACTS_AND_DOCUMENTS_USER_CONTRACTS = '/contracts-and-documents/contracts';
export const CONTRACTS_AND_DOCUMENTS_UPLOAD = '/contracts-and-documents/document-upload';
export const CHANGE_EMAIL = '/change-email';
export const CHANGE_PHONE = '/change-phone';
export const CHANGE_PHONE_OTP = '/change-phone/enter-otp';
export const DEFERRED_BILLING = '/odlozeni-splatnosti';
export const DEFERRED_BILLING_POSTPONEMENT_FREE = `${DEFERRED_BILLING}#free-deferment`;
export const DOCUMENTS = '/dokumenty';
export const REFUND_FORM = '/vraceni-preplatku';
export const DIRECT_DEBIT = '/direct-debit';
export const DIRECT_DEBIT_SUCCESS = '/direct-debit/success';
export const ESHOPS_LIST = '/kde-nakupovat';
export const ESHOPS_LIST_PAY_IN_THREE = `${ESHOPS_LIST}?meth=payInThree`;
export const ESHOPS_LIST_DEFERRED_PAYMENT = `${ESHOPS_LIST}?meth=deferredPayment`;
export const EXCHANGE_RATES = '/kurzovni-listek';
export const FOR_JOURNALISTS = '/pro-novinare';
export const FOR_DEVELOPERS = '/pro-vyvojare';
export const FORGOTTEN_PASSWORD = '/forgotten-password';
export const FORGOTTEN_PASSWORD_CALLBACK = '/forgotten-password/:token';
export const GET_MALL_PAY = '/pro-eshop';
export const GET_MALL_PAY_INSURANCE = '/pro-eshop/pojisteni';
export const HISTORICAL_APPLICATION_DETAIL = `${APPLICATIONS_BILLINGS_BASE}/bnpl/:applicationId`;
export const INCREASE_LIMIT = '/limit-increase';
export const INFORMATION_MEMORANDUM = '/informacni-memorandum';
export const CONTRACTS_AND_DOCUMENTS_INFORMATION_MEMORANDUM =
	'/contracts-and-documents/information-memorandum';
export const INSURANCE_EVENT_REPORT = '/report-insurance-claim';
export const INSURANCE_TO_CARD = '/pojisteni-ke-karte';
export const INSTALLMENTS = '/installments';
export const INSTALLMENT_DETAIL = '/installments/:installmentId';
export const INSTALLMENT_APPLICATION_CREATE = `/installments/application/${NEW_INSTALLMENT_APPLICATION_URL}`;
export const INSTALLMENTS_APPLICATION_SELECT = '/installments/discount-selection';
export const INSTALLMENT_APPLICATION = '/installments/application/:applicationId';
export const INSTALLMENT_APPLICATION_PAYMENT = '/installments/:installmentId/pay';
export const INSTALLMENT_APPLICATION_EXTRAORDINARY_PAYMENT =
	'/installments/:installmentId/extraordinary-payment';
export const INSTALLMENT_APPLICATION_EARLY_PAYMENT = '/installments/:installmentId/early-repayment';
export const INSTALLMENTS_HISTORY = '/installments/history';
export const INTRO = '/introduction';
export const INVESTMENTS = '/investments';
export const INVESTMENTS_MANAGEMENT = '/investments/management';
export const INVESTMENT_TRANSACTION = '/investments/transactions/:transactionId';
export const KYC_VERIFICATION = '/verification';
export const LOGIN = '/login';
export const LOGOUT = '/logout';
export const MY_APPLICATION_LISTING = APPLICATIONS_BILLINGS_BASE;
export const MOBILE_APP = '/mobilni-aplikace';
export const OPEN_API = '/openapi';
export const OVERVIEW = '/overview';
export const PACKAGES = '/balicky';
export const PARTNERS = '/partneri';
export const PAY_IN_THREE = '/pay-in-three';
export const PAY_IN_THREE_DETAIL = '/pay-in-three/:applicationId';
export const PAY_IN_THREE_DETAIL_PAYMENT = '/pay-in-three/:applicationId/pay';
export const PAYMENT = '/pay/:applicationIds';
export const PAYMENT_GATEWAY = '/payment';
export const PAYMENT_PARTIAL = `/pay`;
export const PAYMENT_CARD = '/payment-card';
export const PAYMENT_CARD_ADD_TO_WALLET = '/payment-card/add-to-wallet';
export const PERSONAL_DATA = '/sprava-osobnich-udaju';
export const PRICING = '/cenik';
export const PRICING_OLD = '/cenik#oldDocuments';
export const PRIVACY_SETTINGS = '/nastaveni-soukromi';
export const PRIVATE_CAMPAIGN = '/private/campaign';
export const PROFILE = '/profile';
export const PROFILE_BASIC_INFO = '/profile?section=basicInfo';
export const PUBLIC_REFERRALS = '/doporucte-nas';
export const PUBLIC_SUPPORT = '/caste-dotazy';
export const PUBLIC_SUPPORT_CATEGORY = '/caste-dotazy/:categorySlug';
export const PUBLIC_SUPPORT_QUESTION = '/caste-dotazy/:categorySlug/:questionSlug';
export const PEP_QUESTIONNAIRE = '/pep-questionnaire';

export const REFERRALS = '/referral';
export const REFERRAL_LINK = '/referral/:referrerToken';
export const REGISTRATION = '/registration';
export const REGISTRATION_CALLBACK = '/complete-registration/:token';
export const REGISTRATION_COMPLETION = '/complete-registration';
export const REGISTRATION_CSOB_PROMO = '/csob'; // TODO vno20190608: remove after promo end
export const REGISTRATION_SUCCESS = '/registration-success';
export const REVOLVING_TRANSACTION_DETAIL = `${APPLICATIONS_BILLINGS_BASE}/transactions/:transactionId`;
export const AUTHORIZATION_TRANSACTION_DETAIL = `${APPLICATIONS_BILLINGS_BASE}/authorizations/:transactionId`;
export const REWARD_FREE_DELIVERY_PATH = 'free-delivery-pick-up';
export const REWARDS = '/rewards';
export const REWARD_FREE_DELIVERY = `${REWARDS}/${REWARD_FREE_DELIVERY_PATH}`;
export const REWARDS_BENEFITS = '/rewards/skip-pay-benefits';
export const REWARDS_CSOB = '/rewards/csob-benefits';
export const REWARDS_FROM_PARTNERS = '/rewards/discounts';
export const REWARDS_PROMOCODE_OFFER_DETAIL = '/rewards/:promocodeOfferId';
export const REWARDS_PURCHASED_PROMOCODE_DETAIL = '/rewards/my-rewards/:promocodeOfferId';
export const REWARDS_PURCHASED_PROMOCODES = '/rewards/my-rewards';
export const REWARDS_TRANSACTION_HISTORY = '/rewards/history';
export const RECEIPTS = '/receipts';
export const ROOT = '/';
export const SEND_MONEY = `/send-payment`;
export const SEND_MONEY_PAYMENT_INFORMATION = `/send-payment/payment-details`;
export const PAYMENT_ORDER_TEMPLATES = '/recurring-payments';
export const PAYMENT_ORDER_TEMPLATE = '/recurring-payments/:templateId';
export const SIMPLE_ID = '/mobile-verification';
export const SMS = '/sms';
export const TESTIMONIAL = '/recenze-klientu';
export const UPSELL_SERVICE_BNPL_CREATE =
	'/purchases/bnpl/:applicationId/insurance/:upsellApplicationId/create';
export const UPSELL_SERVICE_TRANSACTION_CREATE =
	'/purchases/transactions/:transactionId/insurance/:upsellApplicationId/create';

export const UPSELL_SERVICE_BNPL_CREATE_NEW = '/purchases/bnpl/:applicationId/insurance/new/create';
export const UPSELL_SERVICE_TRANSACTION_CREATE_NEW =
	'/purchases/transactions/:transactionId/insurance/new/create';
export const UPSELL_SERVICE_REFUND_FORM = '/hlaseni-skody';
export const WHEEL_OF_FORTUNE = '/rewards/wheel-of-fortune';
export const BILLING_DEFERMENT_FOR_COINS = 'odlozeni-zdarma-za-body';
export const XMAS = '/zaplatim-po-vanocich';
export const SPRING = '/my-to-platime';
export const AFFILIATE_PAGE = '/slevy';
export const AFFILIATE_PAGE_DETAIL = '/slevy/:slug';
export const INFORMATION_MEMORANDUM_GENERATED_HTML = '/dokumenty/generated/informacni-memorandum';
export const PRIVACY_POLICY_GENERATED_HTML = '/dokumenty/generated/privacy-policy';
export const DEBT_REPAYMENT_CONFIRMATION = '/installment-calendar/request/:applicationId';
export const PAYMENT_DATA = '/payment-details/:token';

// mobile routes used in self-care components
export const AUTHORIZATION_DETAIL = '/authorization/:authorizationId';
export const AUTHORIZATION_SETTING_INFO = '/transaction-authorization';
export const CONTACT = '/contact';
export const MAP = '/map';
export const MAP_DETAIL = '/map/:id';
export const MORE = '/more';
export const PIN_CHANGE = '/pin/change';
export const WELCOME = '/welcome';

// external
export const APP_ANDROID = 'https://play.google.com/store/apps/details?id=cz.mallpay&hl=cs';
export const APP_IPHONE = 'https://apps.apple.com/app/id1450758826';
export const URL_FACEBOOK = 'https://www.facebook.com/SkipPay/';
export const URL_LINKEDIN = 'https://www.linkedin.com/company/skip-pay/';
export const URL_INSTAGRAM = 'https://www.instagram.com/skip_pay/';
export const URL_MOB_APP_APPLE_APP_STORE = `https://apps.apple.com/app/id1450758826`;
export const URL_MOB_APP_GOOGLE_PLAY = `https://play.google.com/store/apps/details?id=cz.mallpay&hl=cs`;
export const URL_YOUTUBE = 'https://www.youtube.com/channel/UC56ivZwb5fjA7ClI49aMyIg';
export const CSOB_ONLINE_BANKING_LOGIN = 'https://identita.csob.cz/prihlaseni/#csob-ib';
export const SMART_MOBILE_ONLINE_BANKING_LOGIN = 'https://smart.csob.cz/smartbanking/login';
export const CSOB_ACCOUNT_LINK = 'https://www.csob.cz/lide/ucty/ucet-se-skippay';
export const CASHBACK_PROMO_LINK = 'https://promo.skippay.cz/cashback';

type Routes = {
	conditions: string;
	informationMemorandum: string;
	informationMemorandumGenerated: string;
	privacyPolicyGenerated: string;
	support: string;
	supportCategory: string;
	supportQuestion: string;
	mobileApp: string;
	iWantApp: string;
	personalData: string;
	pricing: string;
	pricingOld: string;
	contacts: string;
	partners: string;
	eshopsList: string;
	eshopsListPayInThree: string;
	eshopsListDeferredPayment: string;
	faqWultra: string;
};

// CS / SK Routes

const CS_ROUTES: Routes = {
	conditions: CONDITIONS,
	informationMemorandum: INFORMATION_MEMORANDUM,
	informationMemorandumGenerated: INFORMATION_MEMORANDUM_GENERATED_HTML,
	privacyPolicyGenerated: PRIVACY_POLICY_GENERATED_HTML,
	support: PUBLIC_SUPPORT,
	supportCategory: PUBLIC_SUPPORT_CATEGORY,
	supportQuestion: PUBLIC_SUPPORT_QUESTION,
	mobileApp: MOBILE_APP,
	iWantApp: APP_STORE_REDIRECT,
	personalData: PERSONAL_DATA,
	pricing: PRICING,
	pricingOld: PRICING_OLD,
	contacts: CONTACTS,
	partners: PARTNERS,
	eshopsList: ESHOPS_LIST,
	eshopsListPayInThree: ESHOPS_LIST_PAY_IN_THREE,
	eshopsListDeferredPayment: ESHOPS_LIST_DEFERRED_PAYMENT,
	faqWultra: 'https://skippay.cz/caste-dotazy/mobilni-aplikace/jak-chranime-vase-data-a-finance',
};

const SK_ROUTES: Routes = {
	conditions: '/vseobecne-obchodne-podmienky',
	informationMemorandum: '/informacne-memorandum',
	informationMemorandumGenerated: '/dokumenty/generated/informacne-memorandum',
	privacyPolicyGenerated: '/dokumenty/generated/privacy-policy',
	support: '/casto-kladene-otazky',
	supportCategory: '/casto-kladene-otazky/:categorySlug',
	supportQuestion: '/casto-kladene-otazky/:categorySlug/:questionSlug',
	mobileApp: '/mobilna-aplikacia',
	iWantApp: '/chcem-aplikaciu',
	personalData: '/sprava-osobnych-udajov',
	pricing: '/cennik',
	pricingOld: '/cennik#oldDocuments',
	contacts: CONTACTS,
	partners: PARTNERS,
	eshopsList: ESHOPS_LIST,
	eshopsListPayInThree: ESHOPS_LIST_PAY_IN_THREE,
	eshopsListDeferredPayment: ESHOPS_LIST_DEFERRED_PAYMENT,
	faqWultra: 'https://skippay.sk/casto-kladene-otazky/mobilna-aplikacia/ako-chranime-vase-data',
};

const HU_ROUTES: Routes = {
	conditions: '/terms-and-conditions',
	informationMemorandum: '/information-memorandum',
	informationMemorandumGenerated: '/documents/generated/information-memorandum',
	privacyPolicyGenerated: '/documents/generated/privacy-policy',
	support: '/faq',
	supportCategory: '/faq/:categorySlug',
	supportQuestion: '/faq/:categorySlug/:questionSlug',
	mobileApp: '/mobile-app',
	iWantApp: '/i-want-app',
	personalData: '/personal-data-management',
	pricing: '/pricing',
	pricingOld: '/pricing#oldDocuments',
	contacts: '/contact',
	partners: '/partners',
	eshopsList: `/where-to-shop`,
	eshopsListPayInThree: `/where-to-shop?meth=payInThree`,
	eshopsListDeferredPayment: `/where-to-shop?meth=deferredPayment`,
	faqWultra: 'https://skippay.hu/faq/mobil-alkalmazas/mobilalkalmazas-kikapcsolasa',
};

export const ROUTES = (locale: Locale = 'cs'): Routes => {
	switch (locale) {
		case 'cs':
			return CS_ROUTES;
		case 'sk':
			return SK_ROUTES;
		case 'hu':
			return HU_ROUTES;
		default:
			throw new Error('Locale is not supported yet');
	}
};
